import { MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { ADDRESS, EMAIL, MAPS_URL, PHONE_DISPLAY, PHONE_TEL, WA_URL } from "@/constants/neco";
import { trackWhatsAppClick } from "@/lib/gtag";

export const Footer = () => (
  <footer id="iletisim" data-testid={HOME.footerSection} className="bg-[#0E0D0C] pt-24 pb-12 border-t border-[#D4AF37]/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-8" data-testid={HOME.contactSection}>
      <p className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]">İletişim</p>
      <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-[#F5F5F0] mt-5 gold-rule">
        Sizi Ağırlamaktan <span className="font-romance text-[#E5C783]">Mutluluk Duyarız</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mt-16">
        <div className="flex items-start gap-4">
          <MapPin size={20} strokeWidth={1.5} className="text-[#D4AF37] shrink-0 mt-1" />
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#B3B0A8]">Adres</p>
            <p className="text-sm font-light text-[#F5F5F0] mt-2 leading-relaxed">
              Neco Plaza
              <br />
              Samsun Fuar İçi
              <br />
              55030 İlkadım / Samsun
            </p>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-3 text-xs uppercase tracking-[0.2em] text-[#E5C783] hover:text-[#D4AF37] transition-colors duration-300"
            >
              Yol Tarifi →
            </a>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <Phone size={20} strokeWidth={1.5} className="text-[#D4AF37] shrink-0 mt-1" />
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#B3B0A8]">Telefon</p>
            <a href={PHONE_TEL} className="block text-sm font-light text-[#F5F5F0] mt-2 hover:text-[#E5C783] transition-colors duration-300">
              {PHONE_DISPLAY}
            </a>
            <p className="text-xs font-light text-[#B3B0A8] mt-1">Faks: +90 362 435 45 25</p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <MessageCircle size={20} strokeWidth={1.5} className="text-[#D4AF37] shrink-0 mt-1" />
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#B3B0A8]">WhatsApp</p>
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} className="block text-sm font-light text-[#F5F5F0] mt-2 hover:text-[#E5C783] transition-colors duration-300">
              0532 475 64 61
            </a>
            <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 text-xs font-light text-[#B3B0A8] mt-2 hover:text-[#E5C783] transition-colors duration-300">
              <Mail size={12} /> {EMAIL}
            </a>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <Clock size={20} strokeWidth={1.5} className="text-[#D4AF37] shrink-0 mt-1" />
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#B3B0A8]">Çalışma Saatleri</p>
            <p className="text-sm font-light text-[#F5F5F0] mt-2 leading-relaxed">
              Hafta içi
              <br />
              09.00 – 19.00
            </p>
          </div>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-[#D4AF37]/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="flex items-center gap-3">
          <img src="/images/neco-logo.png" alt="Neco Plaza logosu" className="h-12 w-12 object-contain" />
          <span className="font-display text-xl text-[#F5F5F0]">
            Neco <span className="text-[#D4AF37]">Plaza</span>
            <span className="ml-3 text-[10px] uppercase tracking-[0.3em] text-[#B3B0A8]">1973'ten beri</span>
          </span>
        </p>
        <p className="text-xs text-[#B3B0A8]/60">
          © {new Date().getFullYear()} Neco Plaza — Tüm hakları saklıdır.
        </p>
      </div>
    </div>
  </footer>
);
